import { createQueryKeys } from "@lukemorales/query-key-factory";
import { skipToken } from "@tanstack/react-query";

import { listConsentDocumentsToSign } from "~/patients/api/consentDocuments";
import { ConsentDocumentsToSignRequest } from "~/patients/types/consentDocuments";

export const consentDocumentsToSignQueryOptionsFactory = createQueryKeys(
  "consent-documents-to-sign",
  {
    list: ({ organizationId }: ConsentDocumentsToSignRequest) => ({
      queryKey: [organizationId],
      queryFn: organizationId
        ? () => listConsentDocumentsToSign({ organizationId })
        : skipToken,
    }),
  },
);
